import { useObrasTable } from "./use-obras-table";
import { ObrasTableView } from "./view-obras-table";
import type { ObrasTableProps } from "./types-obras-table";

export function ObrasTable(props: ObrasTableProps) {
  const vm = useObrasTable(props);

  return <ObrasTableView {...vm} />;
}

export type * from "./types-obras-table";
